import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class EventListenerService {

    public close: EventEmitter<string> = new EventEmitter();

    constructor() {
        // this.eventListener = new EventEmitter<string>();
    }

    closeEvent(action) {
        console.log('in the service : ', action);
        this.close.emit(action);
    }
}
